import { createClient, type SanityClient } from "@sanity/client";

let client: SanityClient | null = null;

/** `mock` 強制只用 mock；其餘在設了 VITE_SANITY_PROJECT_ID 時走 Sanity */
export function postsSourceMode(): "sanity" | "mock" {
  const mode = (import.meta.env.VITE_CONTENT_POSTS_SOURCE as string | undefined)?.trim().toLowerCase();
  if (mode === "mock") return "mock";
  if (import.meta.env.VITE_SANITY_PROJECT_ID?.trim()) return "sanity";
  return "mock";
}

export function isSanityPostsEnabled(): boolean {
  return postsSourceMode() === "sanity";
}

export function getSanityClient(): SanityClient | null {
  if (!isSanityPostsEnabled()) return null;
  if (client) return client;
  const projectId = import.meta.env.VITE_SANITY_PROJECT_ID as string;
  const dataset = (import.meta.env.VITE_SANITY_DATASET as string | undefined)?.trim() || "production";
  const apiVersion = (import.meta.env.VITE_SANITY_API_VERSION as string | undefined)?.trim() || "2024-01-01";
  const useCdn = import.meta.env.VITE_SANITY_USE_CDN !== "false";
  const token = (import.meta.env.VITE_SANITY_READ_TOKEN as string | undefined)?.trim();

  client = createClient({
    projectId,
    dataset,
    apiVersion,
    useCdn,
    ...(token ? { token, ignoreBrowserTokenWarning: true } : {}),
  });
  return client;
}
